import React from "react";
import PanelHead from "../../../UI/Panel/PanelHead";
import PanelBody from "../../../UI/Panel/PanelBody";
import {MemberShipGroupTable} from "../../../UI/MembershipGroup/MemberShipGroupTable";

const MemberShipGroup = () => {
  return (
    <div>
      <PanelHead title="Membership Groups" />
      <PanelBody content={<MemberShipGroupTable />} />
    </div>
  );
};

export default React.memo(MemberShipGroup);
